import { memo } from 'react';
import type { IIconProps } from '../interfaces';

const ImportIcon = (props: IIconProps) => {
  const { width = 24, height = 24, color = 'currentColor' } = props;

  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17 12.5H21.5C21.6989 12.5 21.8897 12.579 22.0303 12.7197C22.171 12.8603 22.25 13.0511 22.25
          13.25V19.25C22.25 19.4489 22.171 19.6397 22.0303 19.7803C21.8897 19.921 21.6989 20 21.5 20H3.5C3.30109
          20 3.11032 19.921 2.96967 19.7803C2.82902 19.6397 2.75 19.4489 2.75 19.25V13.25C2.75 13.0511 2.82902 12.8603
          2.96967 12.7197C3.11032 12.579 3.30109 12.5 3.5 12.5H8"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M12.5 2.75V12.5" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M8 8L12.5 12.5L17 8" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M18.125 17.375C18.7463 17.375 19.25 16.8713 19.25 16.25C19.25 15.6287 18.7463 15.125 18.125 15.125C17.5037 15.125 17 15.6287 17 16.25C17 16.8713 17.5037 17.375 18.125 17.375Z"
        fill={color}
      />
    </svg>

  );
};

export default memo(ImportIcon);
